<div style="width: 50vw; height: 98vh;" data-cy="medical-history-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="medical-history-header-section">
      <div class="section-header-title" data-cy="medical-history-title-text">
        Patient Medical and Medication History
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; overflow: hidden;" data-cy="medical-history-content-section">
      <div style="display: flex; flex-direction: column; height: 100%;">
        <div style="flex: 1; display: flex; flex-direction: column; overflow: hidden;" data-cy="medical-history-medication-section">
          <div style="flex-basis: fit-content; display: flex;" data-cy="medical-history-medication-header">
            <div style="flex: 1; font-weight: 500;" data-cy="medical-history-medication-title">Medication History</div>
            <div (click)="addMedication()" style="flex-basis: 30px; color: var(--tdo-primary-accent); cursor: pointer;" data-cy="medical-history-add-medication-button">
              <mat-icon>add_circle_outline</mat-icon>
            </div>
            <div style="flex-basis: 300px;" data-cy="medical-history-dropdown-container">
              <tdo-dropdown-v2 [value]="selectedMedicationHistory" [datasource]="listMedicationHistory"
                               displayProperty="display"
                               (selectionChange)="onChangeMedicationHistory($event)" data-cy="medical-history-medication-dropdown"></tdo-dropdown-v2>
            </div>
          </div>
          <div style="width: 100%;" *ngIf="isLoadingMedicationHistory" data-cy="medical-history-medication-loading">
            <app-tdo-progress-spinner></app-tdo-progress-spinner>
          </div>
          <div style="flex: 1; overflow-y: hidden;" *ngIf="!isLoadingMedicationHistory" data-cy="medical-history-medication-table-container">
            <tdo-table #medicationTable [dataSource]="medicationHistory" [isSearchable]="false"
                       [isShowHeadersIfNoData]="true" data-cy="medical-history-medication-table">
              <tdo-table-column displayName="Medication" propertyName="resMRXMedication" [rowTemplate]="medication">
                <ng-template #medication let-row>
                  {{row.resMRXMedication}}
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Quantity" propertyName="resMRXQuantity" [rowTemplate]="quantity">
                <ng-template #quantity let-row>
                  {{row.resMRXQuantity}}
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Frequency" propertyName="resMRXFrequency" [rowTemplate]="frequency">
                <ng-template #frequency let-row>
                  {{row.resMRXFrequency}}
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Start Date" propertyName="resMRXStartDate" [rowTemplate]="startDate">
                <ng-template #startDate let-row>
                  {{row.resMRXStartDate | date: 'shortDate' }}
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Reason" propertyName="resMRXReason" [rowTemplate]="reason">
                <ng-template #reason let-row>
                  {{row.resMRXReason}}
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Last Taken Date" propertyName="resMRXLastTaken"
                                [rowTemplate]="lastTakenDate">
                <ng-template #lastTakenDate let-row>
                  {{row.resMRXLastTaken  | date: 'shortDate'}}
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Stopped Taking" propertyName="resMRXStppedTagingIt"
                                [rowTemplate]="stoppedTaking">
                <ng-template #stoppedTaking let-row>
                  {{row.resMRXStppedTagingIt}}
                </ng-template>
              </tdo-table-column>
            </tdo-table>
          </div>
        </div>
        <div style="flex: 1; overflow-y: hidden; display: flex; flex-direction: column;" data-cy="medical-history-rx-section">
          <div style="flex-basis: fit-content; font-weight: 500;" data-cy="medical-history-rx-title">Rx History</div>
          <div style="flex: 1; overflow-y: hidden;" data-cy="medical-history-rx-table-container">
            <tdo-table #rxHistory [dataSource]="medicationRxHistory" [isSearchable]="false"
                       [isShowHeadersIfNoData]="true" data-cy="medical-history-rx-table">
              <tdo-table-column displayName="Medication" propertyName="Medication" [rowTemplate]="medication">
                <ng-template #medication let-row>
                  {{row.Medication}}
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Quantity" propertyName="DispenseQuantity" [rowTemplate]="quantity">
                <ng-template #quantity let-row>
                  {{row.DispenseQuantity}}
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Frequency" propertyName="Dosage" [rowTemplate]="frequency">
                <ng-template #frequency let-row>
                  {{row.Dosage}} {{row.DosageForm}}
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Start Date" propertyName="StartDate" [rowTemplate]="startDate">
                <ng-template #startDate let-row>
                  {{row.StartDate|date}}
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Directions" propertyName="Directions" [rowTemplate]="directions">
                <ng-template #directions let-row>
                  {{row.Directions}}
                </ng-template>
              </tdo-table-column>
              <!--<tdo-table-column displayName="Last Taken Date" propertyName="resMRXLastTaken" [rowTemplate]="lastTakenDate">
                <ng-template #lastTakenDate let-row>
                  {{row.resMRXLastTaken}}
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Stopped Taking" propertyName="resMRXStppedTagingIt" [rowTemplate]="stoppedTaking">
                <ng-template #stoppedTaking let-row>
                  {{row.resMRXStppedTagingIt}}
                </ng-template>
              </tdo-table-column>!-->
            </tdo-table>
          </div>
        </div>
        <div style="flex: 1; display: flex; flex-direction: column; overflow: hidden;" data-cy="medical-history-medical-section">
          <div style="flex-basis: fit-content; display: flex;" data-cy="medical-history-medical-header">
            <div style="flex: 1; font-weight: 300px;" data-cy="medical-history-medical-title">Medical History</div>
            <div (click)="addMedical()" style="flex-basis: 30px; color: var(--tdo-primary-accent); cursor: pointer;" data-cy="medical-history-add-medical-button">
              <mat-icon>add_circle_outline</mat-icon>
            </div>
            <div style="flex-basis: 500px;" data-cy="medical-history-medical-dropdown-container">
              <tdo-dropdown-v2 [value]="selectedMedicalHistory" [datasource]="listMedicalHistory"
                               displayProperty="display"
                               (selectionChange)="onChangeMedicalHistory($event)" data-cy="medical-history-medical-dropdown"></tdo-dropdown-v2>
            </div>
          </div>
          <div style="flex: 1; overflow-y: hidden;" data-cy="medical-history-medical-table-container">
            <tdo-table #medicalTable [dataSource]="medicalHistory" [isSearchable]="false"
                       [isShowHeadersIfNoData]="true" data-cy="medical-history-medical-table">
              <tdo-table-column displayName="Problem" propertyName="problem" [rowTemplate]="problem">
                <ng-template #problem let-row>
                  {{row.problem}}
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Patient Note" propertyName="patientNote" [rowTemplate]="patientNote">
                <ng-template #patientNote let-row>
                  {{row.patientNote}}
                </ng-template>
              </tdo-table-column>
              <tdo-table-column displayName="Doctor Note" propertyName="resultid" [rowTemplate]="resultid">
                <ng-template #resultid let-row>
                  <div style="display: flex; width: 100%; margin: 0; padding: 0;  " data-cy="anesthesia-autofill-entry">
                    <app-tdo-simple-note height="50px" style="width: 100%" [numRows]="1" #simpleNote
                                         [categoryEnumId]="NoteCategoryEnum.MedicalHistorySummary"
                                         [typeEnumId]="NoteTypeEnum.Administartive" [PatientId]="patientId"
                                         parentObjectName="dataFormResultId"
                                         [objectId]="row.resultid"></app-tdo-simple-note>
                  </div>
                </ng-template>
              </tdo-table-column>
              <!--<tdo-table-column displayName="Name" propertyName="Name" [rowTemplate]="autoFill"
                                isSortable="true">
                <ng-template #autoFill let-row>
                  <div style="display: flex; width: 100%;" data-cy="anesthesia-autofill-entry">
                    <input [value]="row.model.Name"
                           (appDirtyBlur)="onNameInputFihished($event)"
                           style="border: unset; border-bottom: 1px solid #f1f1f1; flex: 1; background-color: unset;" />
                    <div style="cursor: pointer; color: var(--tdo-secondary);"
                         (click)="onDeleteAutoFill(row.model)"><mat-icon>delete</mat-icon>
                    </div>
                  </div>
                </ng-template>
              </tdo-table-column>!-->
            </tdo-table>
          </div>
        </div>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 46px; min-height: 46px; padding-top: 6px;" data-cy="medical-history-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="medical-history-cancel-button">Cancel</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="medical-history-ok-button">Ok</button>
    </div>
  </div>
</div>
